import React from 'react';
import { Pill } from 'src/components/UI';
import styles from './styles.module.scss';

interface OfferTagProps {
    labels: (string | null)[];
    // variant?: 'full' | 'truncated';
}

function OfferTags({ labels }: OfferTagProps) {
    const filteredLabels = labels.filter((label) => !!label);
    const pills = filteredLabels.map((label) => (
        <li key={label}>
            <Pill className={styles.pill}>{label}</Pill>
        </li>
    ));
    return <ul className={styles.pillList}>{pills}</ul>;
}

export default OfferTags;
